module.exports = __webpack_public_path__ + "static/media/aidenjauffret.383e1fef.jpeg";